import React, { useEffect, useRef, useState } from "react";
import { Card } from "../../../_metronic/_partials/controls";
import { baseUrl } from "../../../services/config";
import { useAlert } from "react-alert";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { MdDelete } from "react-icons/md";
import Select from "react-select";
import { useUnitSettings } from "../../../context/UnitSettingsContext";

const UnitSettings = () => {
  const authToken = localStorage.getItem("userToken");
  const [roleList, setRoleList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [fineAmount, setFineAmount] = useState("");
  const [unitName, setUnitName] = useState("");
  const [gpFundYear, setGpFundYear] = useState("");
  const [directorNo, setDirectorNo] = useState("");
  const [alphanumericAdmNo, setAlphanumericAdmNo] = useState(false);
  const [alphanumericRegNo, setAlphanumericRegNo] = useState(false);
  const [directorSign, setDirectorSign] = useState(false);
  const [sendMsg, setSendMsg] = useState(false);
  const [useReadmissionFee, setUseReadmissionFee] = useState(false);
  const [deductGPFund, setDeductGPFund] = useState(false);
  const [challanInstruction, setChallanInstruction] = useState(false);
  const [controllerSignature, setControllerSignature] = useState(false);
  const [studentExamRemarks, setStudentExamRemarks] = useState(false);
  const [challansPerPage, setChallansPerPage] = useState(12);
  const [voucherDateRestriction, setVoucherDateRestriction] = useState(false);
  const [partialFee, setPartialFee] = useState(false);
  const [bankQRCodes, setBankQRCodes] = useState(false);
  const [offlineStudentPrint, setOfflineStudentPrint] = useState(1);
  const [SMSApiLogin, setSMSApiLogin] = useState("");
  const [SMSApiPassword, setSMSApiPassword] = useState("");
  const [bankApiClientId, setBankApiClientId] = useState("");
  const [bankApiClientSecret, setBankApiClientSecret] = useState("");
  const [headOfficeUrl, setHeadOfficeUrl] = useState("");
  const [lahoreHeadOfficeUrl, setLahoreHeadOfficeUrl] = useState("");
  const [staffRoleId, setStaffRoleId] = useState("");
  const [domainSlug, setDomainSlug] = useState("");
  const [unitId, setUnitId] = useState(null);
  const [saveBtn, setSaveBtn] = useState(true);

  const [logoUpload, setLogoUpload] = useState(null);
  const [startLogoUpload, setStartLogoUpload] = useState(null);
  const [signatureUpload, setSignatureUpload] = useState(null);

  const file1Ref = useRef(null);
  const file2Ref = useRef(null);
  const file3Ref = useRef(null);

  const alert = useAlert();
  const { settings, refreshSettings } = useUnitSettings();

  useEffect(() => {
    getRoles();
    getCustomers();
  }, []);

  useEffect(() => {
    // Cached shell settings are intentionally partial. Wait for the complete
    // server response before enabling the editor.
    if (!settings || settings.staff_role_id === undefined) return;

    setFineAmount(settings.late_fee_fine);
    setUnitName(settings.unit_name);
    setGpFundYear(settings.gp_fund_years);
    setDirectorNo(settings.director_number);
    setAlphanumericAdmNo(settings.alphanumeric_adm_no);
    setAlphanumericRegNo(settings.alphanumeric_registration_no);
    setDirectorSign(settings.director_sign);
    setSendMsg(settings.send_message);
    setUseReadmissionFee(settings.use_readmission_fee);
    setDeductGPFund(settings.deduct_gp_fund);
    setPartialFee(settings.partial_fee);
    setOfflineStudentPrint(
      settings.offline_student_print === undefined
        ? 1
        : settings.offline_student_print,
    );
    setChallanInstruction(settings.challan_instruction);
    setControllerSignature(settings.controller_signature);
    setStudentExamRemarks(settings.student_exam_remarks);
    setChallansPerPage(settings.challans_per_page);
    setSMSApiLogin(settings.sms_api_login);
    setSMSApiPassword(settings.sms_api_password);
    setBankApiClientId(settings.bank_api_client_id);
    setBankApiClientSecret(settings.bank_api_client_secret);
    setBankQRCodes(settings.bank_qr_codes);
    setHeadOfficeUrl(settings.head_office_url);
    setLahoreHeadOfficeUrl(settings.lahore_head_office_url);
    setVoucherDateRestriction(settings.voucher_date_restriction);
    setStaffRoleId(settings.staff_role_id);
    setUnitId(settings.unit_id);
    setDomainSlug(settings.domain_slug);
    setSaveBtn(false);
  }, [settings]);

  const getRoles = async () => {
    await fetch(`${baseUrl}/roles`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setRoleList(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCustomers = () => {
    fetch(`https://portal.tvoxel.com/api/customers`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];
        data.forEach((element) => {
          arr.push({
            label: element.name,
            value: element.id,
          });
        });
        setCustomerList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLogoUpload = (e) => {
    setLogoUpload({
      image: e.target.files[0],
    });
  };

  const handleStartLogoUpload = (e) => {
    setStartLogoUpload({
      image: e.target.files[0],
    });
  };

  const handleSignatureUpload = (e) => {
    setSignatureUpload({
      image: e.target.files[0],
    });
  };

  const update_setting = async () => {
    if (fineAmount === "") {
      alert.error("Please Enter Fine Amount");
      return;
    }

    if (staffRoleId === "") {
      alert.error("Please Select Staff Role");
      return;
    }

    if (
      Number(challanInstruction) === 1 &&
      (!challansPerPage || parseInt(challansPerPage, 10) < 1)
    ) {
      alert.error("Please Enter Challan Per Page");
      return;
    }

    setSaveBtn(true);

    const data = new FormData();

    console.log(directorNo);

    data.append("late_fee_fine", fineAmount);
    data.append("unit_name", unitName);
    data.append("gp_fund_years", gpFundYear);
    data.append("director_number", directorNo);
    data.append("alphanumeric_adm_no", alphanumericAdmNo);
    data.append("alphanumeric_registration_no", alphanumericRegNo);
    data.append("director_sign", directorSign);
    data.append("send_message", sendMsg);
    data.append("use_readmission_fee", useReadmissionFee);
    data.append("deduct_gp_fund", deductGPFund);
    data.append("challan_instruction", challanInstruction);
    data.append("challan_per_page", parseInt(challansPerPage, 10));
    data.append("partial_fee", partialFee);
    data.append("offline_student_print", offlineStudentPrint);
    data.append("controller_signature", controllerSignature);
    data.append("student_exam_remarks", studentExamRemarks);
    data.append("sms_api_login", SMSApiLogin);
    data.append("sms_api_password", SMSApiPassword);
    data.append("head_office_url", headOfficeUrl);
    data.append("lahore_head_office_url", lahoreHeadOfficeUrl);
    data.append("voucher_date_restriction", voucherDateRestriction);
    data.append("staff_role_id", staffRoleId);
    data.append("domain_slug", domainSlug);
    data.append("unit_id", unitId);
    data.append("bank_api_client_id", bankApiClientId);
    data.append("bank_api_client_secret", bankApiClientSecret);
    data.append("bank_qr_codes", bankQRCodes);

    if (logoUpload) {
      data.append("logo_file", logoUpload.image);
    }
    if (startLogoUpload) {
      data.append("start_logo_file", startLogoUpload.image);
    }
    if (signatureUpload) {
      data.append("signature_file", signatureUpload.image);
    }

    // console.log(data);

    await fetch(`${baseUrl}/update-settings`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: data,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            setSaveBtn(false);
            refreshSettings();
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setSaveBtn(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Card style={{ margin: "10px", padding: 0 }}>
        <form className="m-10">
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="unitName">
                <b>Unit Name</b>
              </label>
              <input
                className="form-control"
                id="unitName"
                value={unitName}
                placeholder="Enter Unit Name"
                onChange={(e) => setUnitName(e.target.value)}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="headofficeurl">
                <b>Head Office Url</b>
              </label>
              <input
                className="form-control"
                type="text"
                id="headofficeurl"
                value={headOfficeUrl}
                placeholder="Enter Head Office URL"
                onChange={(e) => setHeadOfficeUrl(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="lahoreheadofficeurl">
                <b>Lahore Head Office Url</b>
              </label>
              <input
                className="form-control"
                type="text"
                id="lahoreheadofficeurl"
                value={lahoreHeadOfficeUrl}
                placeholder="Enter Lahore Head Office Url"
                onChange={(e) => setLahoreHeadOfficeUrl(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="fineAmount">
                <b>Fine Amount</b>
              </label>
              <input
                className="form-control"
                id="fineAmount"
                value={fineAmount}
                placeholder="Enter Fine Amount"
                onChange={(e) => setFineAmount(e.target.value)}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="gpFundYear">
                <b>GP Fund Deduction Years (From Joining Date)</b>
              </label>
              <input
                className="form-control"
                id="gpFundYear"
                value={gpFundYear}
                placeholder="Enter GP Fund Years"
                onChange={(e) => setGpFundYear(e.target.value)}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="smsapilogin">
                <b>SMS API Login</b>
              </label>
              <input
                className="form-control"
                id="smsapilogin"
                value={SMSApiLogin}
                placeholder="Enter SMS API Login"
                onChange={(e) => setSMSApiLogin(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="smsapipassword">
                <b>SMS API Password</b>
              </label>
              <input
                className="form-control"
                type="password"
                id="smsapipassword"
                value={SMSApiPassword}
                placeholder="Enter Unit Name"
                onChange={(e) => setSMSApiPassword(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="directorNo">
                <b>Director Number</b>
              </label>
              <input
                type="number"
                className="form-control"
                id="directorNo"
                value={directorNo}
                placeholder="Enter Director Number"
                onChange={(e) => setDirectorNo(e.target.value)}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="domainSlug">
                <b>Domain Slug</b>
              </label>
              <input
                type="text"
                className="form-control"
                id="domainSlug"
                value={domainSlug}
                placeholder="Enter Domain Slug"
                onChange={(e) => setDomainSlug(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="challanPerPage">
                <b>Challan Per Page</b>
              </label>
              <input
                type="number"
                min="1"
                className="form-control"
                id="challanPerPage"
                value={challansPerPage}
                placeholder="Enter challan per page"
                onChange={(e) => setChallansPerPage(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="staffRoleId">
                <b>Select Staff Role</b>
              </label>
              <select
                className="form-select h-40px"
                name="staffRoleId"
                aria-label="Default select example"
                value={staffRoleId}
                onChange={(e) => setStaffRoleId(e.target.value)}
              >
                <option value="">Select Staff Role</option>
                {roleList &&
                  roleList.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="staffRoleId">
                <b>Select Unit</b>
              </label>
              <Select
                value={customerList.find((c) => c.value == unitId)}
                onChange={(e) => setUnitId(e ? e.value : null)}
                className="disselect"
                placeholder="Select Unit"
                options={customerList}
                isClearable
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="bankApiClientId">
                <b>Bank API Client ID</b>
              </label>
              <input
                className="form-control"
                id="bankApiClientId"
                value={bankApiClientId}
                placeholder="Enter Bank API Client ID"
                onChange={(e) => setBankApiClientId(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="bankApiClientSecret">
                <b>Bank API Client Secret</b>
              </label>
              <input
                className="form-control"
                type="password"
                id="bankApiClientSecret"
                value={bankApiClientSecret}
                placeholder="Enter Bank API Client Secret"
                onChange={(e) => setBankApiClientSecret(e.target.value)}
              />
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="alphanumericadm"
                  checked={alphanumericAdmNo ? alphanumericAdmNo == 1 : false}
                  onChange={(e) =>
                    setAlphanumericAdmNo(e.target.checked ? 1 : 0)
                  }
                />
                <span />
                &nbsp;&nbsp;&nbsp;Alphanumeric Admission No
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="alphanumericadm"
                  checked={alphanumericRegNo ? alphanumericRegNo == 1 : false}
                  onChange={(e) =>
                    setAlphanumericRegNo(e.target.checked ? 1 : 0)
                  }
                />
                <span />
                &nbsp;&nbsp;&nbsp;Alphanumeric Registration No
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="directorSign"
                  checked={directorSign ? directorSign == 1 : false}
                  onChange={(e) => setDirectorSign(e.target.checked ? 1 : 0)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Director Signature
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="sendMsg"
                  checked={sendMsg ? sendMsg == 1 : false}
                  onChange={(e) => setSendMsg(e.target.checked ? 1 : 0)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Send Message
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="useReadmissionFee"
                  checked={useReadmissionFee ? useReadmissionFee == 1 : false}
                  onChange={(e) =>
                    setUseReadmissionFee(e.target.checked ? 1 : 0)
                  }
                />
                <span />
                &nbsp;&nbsp;&nbsp;Use Re-admission Fee
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="voucherDateRestriction"
                  checked={
                    voucherDateRestriction ? voucherDateRestriction == 1 : false
                  }
                  onChange={(e) =>
                    setVoucherDateRestriction(e.target.checked ? 1 : 0)
                  }
                />
                <span />
                &nbsp;&nbsp;&nbsp;Voucher Date Restriction
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="deductGPFund"
                  checked={deductGPFund ? deductGPFund == 1 : false}
                  onChange={(e) => setDeductGPFund(e.target.checked ? 1 : 0)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Deduct GP Fund
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="partialFee"
                  checked={partialFee ? partialFee == 1 : false}
                  onChange={(e) => setPartialFee(e.target.checked ? 1 : 0)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Partial Fee
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="offlineStudentPrint"
                  checked={Number(offlineStudentPrint) === 1}
                  onChange={(event) =>
                    setOfflineStudentPrint(event.target.checked ? 1 : 0)
                  }
                />
                <span />
                &nbsp;&nbsp;&nbsp;Offline Challan Print
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="challanInstruction"
                  checked={challanInstruction ? challanInstruction == 1 : false}
                  onChange={(e) =>
                    setChallanInstruction(e.target.checked ? 1 : 0)
                  }
                />
                <span />
                &nbsp;&nbsp;&nbsp;Challan Instruction
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="controllerSignature"
                  checked={
                    controllerSignature ? controllerSignature == 1 : false
                  }
                  onChange={(e) =>
                    setControllerSignature(e.target.checked ? 1 : 0)
                  }
                />
                <span />
                &nbsp;&nbsp;&nbsp;Controller Signature
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="studentExamRemarks"
                  checked={studentExamRemarks ? studentExamRemarks == 1 : false}
                  onChange={(e) =>
                    setStudentExamRemarks(e.target.checked ? 1 : 0)
                  }
                />
                <span />
                &nbsp;&nbsp;&nbsp;Student Exam Remarks
              </label>
            </div>

            <div className="col-md-3 pb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  id="bankQRCodes"
                  checked={bankQRCodes ? bankQRCodes == 1 : false}
                  onChange={(e) => setBankQRCodes(e.target.checked ? 1 : 0)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Bank QR Codes
              </label>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 my-4">
              {logoUpload ? (
                <>
                  <img
                    src={URL.createObjectURL(logoUpload.image)}
                    height="60px"
                    width="60px"
                  />

                  <span
                    onClick={() => setLogoUpload(null)}
                    style={{ cursor: "pointer" }}
                    className="svg-icon svg-icon-md svg-icon-danger p-3"
                  >
                    <MdDelete color="#F64E60" />
                  </span>
                </>
              ) : (
                <>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    id="file_1"
                    ref={file1Ref}
                    accept="image/png, image/jpeg, image/svg"
                    onChange={(e) => handleLogoUpload(e)}
                  />
                  <label
                    className="btn btn-icon btn-light btn-sm"
                    htmlFor="file_1"
                  >
                    {
                      <span className="svg-icon svg-icon-md svg-icon-info">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Files/Upload.svg",
                          )}
                        ></SVG>
                      </span>
                    }
                  </label>
                  <label className="form-label">School Logo</label>
                </>
              )}
            </div>

            <div className="col-md-3 my-4">
              {startLogoUpload ? (
                <>
                  <img
                    src={URL.createObjectURL(startLogoUpload.image)}
                    height="60px"
                    width="60px"
                  />

                  <span
                    onClick={() => setStartLogoUpload(null)}
                    style={{ cursor: "pointer" }}
                    className="svg-icon svg-icon-md svg-icon-danger p-3"
                  >
                    <MdDelete color="#F64E60" />
                  </span>
                </>
              ) : (
                <>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    id="file_2"
                    ref={file2Ref}
                    accept="image/png, image/jpeg, image/svg"
                    onChange={(e) => handleStartLogoUpload(e)}
                  />
                  <label
                    className="btn btn-icon btn-light btn-sm"
                    htmlFor="file_2"
                  >
                    {
                      <span className="svg-icon svg-icon-md svg-icon-info">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Files/Upload.svg",
                          )}
                        ></SVG>
                      </span>
                    }
                  </label>
                  <label className="form-label">Start Logo</label>
                </>
              )}
            </div>

            <div className="col-md-3 my-4">
              {signatureUpload ? (
                <>
                  <img
                    src={URL.createObjectURL(signatureUpload.image)}
                    height="60px"
                    width="60px"
                  />

                  <span
                    onClick={() => setSignatureUpload(null)}
                    style={{ cursor: "pointer" }}
                    className="svg-icon svg-icon-md svg-icon-danger p-3"
                  >
                    <MdDelete color="#F64E60" />
                  </span>
                </>
              ) : (
                <>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    id="file_3"
                    ref={file3Ref}
                    accept="image/png, image/jpeg, image/svg"
                    onChange={(e) => handleSignatureUpload(e)}
                  />
                  <label
                    className="btn btn-icon btn-light btn-sm"
                    htmlFor="file_3"
                  >
                    {
                      <span className="svg-icon svg-icon-md svg-icon-info">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Files/Upload.svg",
                          )}
                        ></SVG>
                      </span>
                    }
                  </label>
                  <label className="form-label">Add Signature</label>
                </>
              )}
            </div>
          </div>

          <button
            type="button"
            className="btn btn-primary"
            onClick={update_setting}
            disabled={saveBtn ? true : false}
          >
            Save
          </button>

          {/* <button type="button" className="btn btn-primary" onClick={SendMessage}>
            Send DN Message
          </button> */}
        </form>
      </Card>
    </>
  );
};

export default UnitSettings;
